// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610062016/js/" + chunkId + "." + {"44":"c8a2764f","225":"b8998425","481":"e86eef46","486":"0b69b853","770":"44da9084"}[chunkId] + ".0.5829419960675433.chunk.js";
};